export default "__VITE_ASSET__65d7046e__"